import { buryingPoint } from '../buryingPoint/receive';
import { doAction } from '../../../src/utils';
import bus from '../../../bus';
export function query (isGetedh5, giftList) {
	let da = []
	giftList.map((item, index) => {
		let {h5Action: {ruleId = ''} = {}} = item;
		if (typeof isGetedh5['h' + ruleId] !== 'undefined') {
			let [small, max] = isGetedh5['h' + ruleId];
			if (small > 0 && max === '0') {
				da[index] = true;
			} else {
				da[index] = false;
			}
		} else {
			da[index] = false;
		}
	})
	return da
};

async function queryshow (type, value) {
	try {
		if (type === 'received') {
			const {res: {iRet, sOutValue1}} = await doAction('ame', value, {sServiceType: window._Vue.$actConfig.gameCode});
			return {iRet, sOutValue1}
		}
	} catch (e) {
		console.log(e);
		e.sMsg && alert(e.sMsg);
	}
};
let status = true;
export async function gift (type, value, title) {
	if (status) {
		status = false;
		let res = '';
		try {
			const { sPackageName } = await doAction(type, value);
			alert(`恭喜你获得了${sPackageName}，请查收`);
			bus.$emit('giftReceivedStatus');
			bus.$emit('isLogined');
			buryingPoint(title);
			res = true;
		} catch (e) {
			console.log(e);
			alert(e.sMsg);
			res = false;
		}
		status = true;
		return res
	}
};

export function receive ({type, value}, title, popuptext) {
	if (type === 'link') {
		window.location.href = value;
	} else if (type === 'received') {
		return new Promise((resolve, reject) => {
			window.need('util.modalDialog', Dialog => {
				Dialog.alert(popuptext, {
					onConfirm: () => {
						resolve(gift(type, value, title))
					},
					onCancel: () => {
						console.log('关闭');
					},
				});
			})
		})
	}
};

export default { query, queryshow, receive, gift };



// WEBPACK FOOTER //
// ./src/components/actModules/h5/templates/components/index.js